import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import WaterSportsService from "../../services/watersports.service";

// **Async Thunks**
export const addWaterSports = createAsyncThunk(
  "watersports/addWaterSports",
  async (item, thunkAPI) => {
    try {
      const response = await WaterSportsService.addwaterSports(item);
      return response.data; // Return actual data
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const getwatersportsList = createAsyncThunk(
  "watersports/getwatersportsList",
  async (item, thunkApi) => {
    try {
      const response = await WaterSportsService.getwatersportsList(item);
      return response.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const editWatersports = createAsyncThunk(
  "watersports/editWaterSports",
  async (item, thunkAPI) => {
    try {
      const response = await WaterSportsService.editwaterSports(item);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const deleteWatersports = createAsyncThunk(
  "watersports/deleteWatersports",
  async (id, thunkAPI) => {
    try {
      await WaterSportsService.deleteWaterSports(id);
      return id; // Return only the ID to remove it from state
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

// **Initial State**
const initialState = {
  loading: false,
  error: "",
  waterSports: [],
};

// **Slice**
const watersportsSlice = createSlice({
  name: "watersports",
  initialState,
  extraReducers: (builder) => {
    builder
      // **Handle Get waterSports List**
      .addCase(getwatersportsList.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(getwatersportsList.fulfilled, (state, action) => {
        state.loading = false;
        state.waterSports = action.payload;
      })
      .addCase(getwatersportsList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // **Handle Add waterSports**
      .addCase(addWaterSports.pending, (state) => {
        state.loading = true;
      })
      .addCase(addWaterSports.fulfilled, (state, action) => {
        state.loading = false;
        state.waterSports.push(action.payload);
      })
      .addCase(addWaterSports.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // **Handle Edit waterSports**
      .addCase(editWatersports.pending, (state) => {
        state.loading = true;
      })
      .addCase(editWatersports.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.waterSportswaterSports.findIndex((p) => p.id === action.payload.id);
        if (index !== -1) {
          state.waterSports[index] = action.payload;
        }
      })
      .addCase(editWatersports.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // **Handle Delete waterSports**
      .addCase(deleteWatersports.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteWatersports.fulfilled, (state, action) => {
        state.loading = false;
        state.waterSports = state.waterSports.filter((p) => p.id !== action.payload);
      })
      .addCase(deleteWatersports.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

// **Export Reducer**
export default watersportsSlice.reducer;
